import {Component, OnDestroy, OnInit} from '@angular/core';
import {ROUTES} from './sidebar-routes.config';
import {RouteInfo} from './sidebar.metadata';
import {Router, ActivatedRoute, Routes} from '@angular/router';
import {UserBoardService} from '../../_services/user-board.service';
import {Subscription} from 'rxjs/Rx';
import {MemberMetaData} from '../../_models/_metadata/MemberMetaData';
import {Properties} from '../../_utils/properties';
import {MemberModel} from '../../_models/_firebaseObjects/MemberModel';
import {AuthService} from '../auth/auth.service';
import {User} from 'firebase';
import {UserModel} from '../../_models/_firebaseObjects/UserModel';
import {AdminService} from '../../_services/admin.service';

declare var $: any;

@Component({
  // moduleId: module.id,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit, OnDestroy {
  public menuItems: any[];
  membersSubs: Subscription;
  userDetailsSubs: Subscription;
  private isAdmin = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userBoardService: UserBoardService,
    private authService: AuthService, private adminService: AdminService) {
  }

  ngOnInit() {
    $.getScript('./assets/app/js/core/app-menu.js');
    $.getScript('./assets/app/js/core/app.js');


    this.userDetailsSubs = this.adminService.getUserDetails().subscribe((user: UserModel) => {
      this.menuItems = ROUTES.filter(menuItem => menuItem.title.toLowerCase() !== 'admin');
      if (user && user.role === 'rootAdmin') {
        //this.removeItemsFromLocalStorage();
        this.isAdmin = true;
        this.menuItems = ROUTES.filter(menuItem => menuItem.title.toLowerCase() === 'admin');
      } else if (user) {
        console.log('from sidebar---user is not admin')
        this.membersSubs = this.userBoardService.fetchGymMembers().subscribe((x: any[]) => {
          if (this.getTrainerRequestCount(x) > 0) {
            const ptMenuItem = this.menuItems.find(
              item => item.title.substring(0, 17) === 'Personal Trainers' &&
              item.submenu.length > 0);
            ptMenuItem.title = 'Personal Trainers (' + this.getTrainerRequestCount(x) + ')';
          } else {
            const ptMenuItem = this.menuItems.find(
              item => item.title.substring(0, 17) === 'Personal Trainers' &&
              item.submenu.length > 0);
            ptMenuItem.title = 'Personal Trainers'
          }
        });
      }
    });


    // let pt = this.menuItems.filter(x => x.title === 'Personal Trainers' && x.submenu.length > 0)[0];
    // pt.title += ' (1)';
  }

  removeItemsFromLocalStorage() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('gym_uid');
    localStorage.removeItem('gym_id');
    localStorage.removeItem('gym_name');
    localStorage.removeItem('person_name');
    localStorage.removeItem('gym_logo');
  }


  getTrainerRequestCount(members: any[]) {
    let trainerRequestsCount = 0;
    let trainers = members.filter(m => m.experienceLevel === Properties.experienceLevel.PERSONAL_TRAINER);
    trainers.forEach(t => {
      //console.log(t);
      if (t['ptVerifiedGyms']) {
        let verifiedGyms = [];
        verifiedGyms = t['ptVerifiedGyms'];
        let count = verifiedGyms.filter(vg => vg.toString() === localStorage.getItem('gym_id')).length;
        if (count < 1) {
          //console.log(t.member.fullName + "...." + t.key);
          trainerRequestsCount++;
        }
      } else {
        //console.log(t.member.fullName + "...." + t.key);
        trainerRequestsCount++;
      }
    });
    return trainerRequestsCount;
  }

  ngOnDestroy(): void {
    if(this.membersSubs){
      this.membersSubs.unsubscribe();
    }
    if(this.userDetailsSubs){
      this.userDetailsSubs.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts